import React from "react";
import { Stack } from "@mui/material";
import { formatMinutesToHoursMinutes } from "../../utils/format-time";

// Inline SVG replacement for Iconify "mingcute:flash-fill"
const FlashIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ marginRight: 4, width: 16 }}
  >
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

// Inline SVG replacement for Iconify "solar:clock-circle-outline"
const ClockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: 4, width: 16 }}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const LadderXpTime = ({
  children,
  experiencePoints,
  estimatedTime,
}: {
  children?: React.ReactNode;
  experiencePoints?: number;
  estimatedTime?: number;
  status?: string;
}) => (
  <Stack
    direction="row"
    spacing={1.5}
    alignItems="center"
    sx={{ typography: "caption", color: "success.dark", fontSize: "12px" }}
  >
    <Stack direction="row" alignItems="center">
      <FlashIcon />
      {experiencePoints} XP
    </Stack>
    <Stack direction="row" alignItems="center" sx={{ color: "primary.main", fontSize: "12px" }}>
      <ClockIcon />
      {formatMinutesToHoursMinutes(estimatedTime)}
    </Stack>
    {children}
  </Stack>
);
